const token = localStorage.getItem('apiKey')
export const COMPANY_ID = localStorage.getItem('companyId')

// url constants --- CHANGE HERE !!!!

export const DEPLOY_MODE = process.env.REACT_APP_DEPLOY_MODE; // prod / staging
export const HOSTNAME_OSLOG = process.env.REACT_APP_HOSTNAME_OSLOG;
export const BASE_URL_OSLOG = process.env.REACT_APP_BASE_URL;
export const BASE_URL_API =  process.env.REACT_APP_BASE_URL_API;
export const BASE_URL_APIv5 = process.env.REACT_APP_BASE_URL_APIV5;
export const BASE_URL_JAVAZ_API = process.env.REACT_APP_BASE_URL_JAVAZ_API;
export const BASE_URL_MAPS_MONITORING = process.env.REACT_APP_BASE_URL_MAPS_MONITORING;
export const BASE_URL_APIv4 = process.env.REACT_APP_BASE_URL_APIV4;
export const BASE_URL_API2 = process.env.REACT_APP_BASE_URL_API2;
export const BASE_URL_ADDRESS = process.env.REACT_APP_BASE_URL_ADDRESS;
export const BASE_URL_OSMAP = process.env.REACT_APP_BASE_URL_OSMAP;
export const BASE_URL_API_AMARIS = process.env.REACT_APP_BASE_URL_API_AMARIS;
export const BASE_URL_API_NOMINATIM = process.env.REACT_APP_BASE_URL_API_NOMINATIM;
export const BASE_URL_API_PHP = process.env.REACT_APP_BASE_URL_API_PHP;
export const BASE_URL_OSLOG_ASSETS = process.env.REACT_APP_BASE_URL_OSLOG_ASSETS;
export const BASE_URL_OSLOG_TEMPLATES = process.env.REACT_APP_BASE_URL_OSLOG_TEMPLATES;
export const BASE_URL_OSLOG_IMAGES = process.env.REACT_APP_BASE_URL_OSLOG_IMAGES; 
// export const BASE_URL_API_PHP = 'https://apiv41.oslog.id'

// headers
export const BASE_HEADER = {
    headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
    }
    
}

export const BASE_HEADER1  = (params) => {
    const header = {
        headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${params}`
        }
    }

    return header
}

export const FILE_HEADER = {
    headers: {
        'Content-Type': 'multipart/form-data',
        "Authorization": `Bearer ${token}`
    }
}


// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'toggle_collapse_menu';
export const DRAWER_TYPE = 'drawer_type';
export const FIXED_DRAWER = 'fixed_drawer';
export const COLLAPSED_DRAWER = 'collapsible';
export const MINI_DRAWER = 'mini_drawer';
export const THEME_COLOR = 'theme_color';
export const DARK_THEME = 'dark_theme';
export const WINDOW_WIDTH = 'window-width';
export const SWITCH_LANGUAGE = 'switch-language';
export const CHANGE_DIRECTION = 'change-direction';

export const CHANGE_NAVIGATION_STYLE = 'change-navigation-style';
export const HORIZONTAL_NAVIGATION = 'horizontal_navigation';
export const VERTICAL_NAVIGATION = 'vertical_navigation';

export const HORIZONTAL_MENU_POSITION = 'horizontal_menu_position';
export const ABOVE_THE_HEADER = 'above_the_header';
export const INSIDE_THE_HEADER = 'inside_the_header';
export const BELOW_THE_HEADER = 'below_the_header';

//Contact Module const

export const SHOW_MESSAGE = 'show_message';
export const HIDE_MESSAGE = 'hide_message';

export const FETCH_ALL_CONTACT = 'fetch_all_contact';
export const FETCH_ALL_CONTACT_SUCCESS = 'fetch_all_contact_success';
export const ADD_FAVOURITE = 'add_favourite';
export const ON_CONTACT_SELECT = 'on_contact_select';
export const ON_ADD_CONTACT = 'on_add_contact';
export const ON_CONTACT_CLOSE = 'on_contact_close';
export const ON_FILTER_OPTION_SELECT = 'on_filter_option_select';
export const ON_SAVE_CONTACT = 'on_save_contact';
export const ON_DELETE_CONTACT = 'on_delete_contact';
export const ON_DELETE_SELECTED_CONTACT = 'on_delete_selected_contact';
export const FILTER_CONTACT = 'filter_contact';
export const GET_ALL_CONTACT = 'get_all_contact';
export const GET_UNSELECTED_ALL_CONTACT = 'get_unselected_all_contact';
export const ON_ALL_CONTACT_SELECT = 'on_all_contact_select';
export const UPDATE_SEARCH_USER = 'update_search_user';
export const ON_TOGGLE_DRAWER = 'on_toggle_drawer';
export const HANDLE_REQUEST_CLOSE = 'handle_request_close';
export const HIDE_CONTACT_LOADER = 'hide_contact_loader';

//Auth const
export const SIGNUP_USER = 'signup_user';
export const SIGNUP_USER_SUCCESS = 'signup_user_success';
export const SIGNIN_GOOGLE_USER = 'signin_google_user';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'signin_google_user_success';
export const SIGNIN_FACEBOOK_USER = 'signin_facebook_user';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'signin_facebook_user_success';
export const SIGNIN_TWITTER_USER = 'signin_twitter_user';
export const SIGNIN_TWITTER_USER_SUCCESS = 'signin_twitter_user_success';
export const SIGNIN_GITHUB_USER = 'signin_github_user';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_SUCCESS';
export const SIGNIN_USER = 'signin_user';
export const SIGNIN_USER_SUCCESS = 'signin_user_success';
export const SIGNOUT_USER = 'signout_user';
export const SIGNOUT_USER_SUCCESS = 'signout_user_success';
export const INIT_URL = 'init_url';
export const SET_MENU = 'set_menu'

// Chat Module const

export const FETCH_ALL_CHAT_USER = 'fetch_all_chat_user';
export const FETCH_ALL_CHAT_USER_CONVERSATION = 'fetch_all_chat_user_conversation';
export const FETCH_ALL_CHAT_USER_SUCCESS = 'fetch_all_chat_user_success';
export const FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS = 'fetch_all_chat_user_conversation_success';
export const FILTER_USERS = 'filter_users';
export const ON_SELECT_USER = 'on_select_user';
export const ON_SHOW_LOADER = 'on_show_loader';
export const ON_HIDE_LOADER = 'on_hide_loader';
export const USER_INFO_STATE = 'user_info_state';
export const SUBMIT_COMMENT = 'submit_comment';
export const UPDATE_MESSAGE_VALUE = 'update_message_value';
export const UPDATE_SEARCH_CHAT_USER = 'update_search_chat_user';

//// Mail Module const


export const ADD_LABEL = 'ADD_LABEL';
export const GET_ALL_MAIL = 'get_all_mail';
export const FETCH_ALL_MAIL = 'fetch_all_mail';
export const FETCH_ALL_MAIL_SUCCESS = 'fetch_all_mail_success';
export const GET_IMPORTANT_MAIL = 'get_important_mail';
export const GET_NAV_FILTERS = 'get_nav_filters';
export const GET_NAV_LABELS = 'get_nav_labels';
export const GET_NAV_FOLDER = 'get_nav_folder';
export const GET_READ_MAIL = 'get_read_mail';
export const GET_STARRED_MAIL = 'get_starred_mail';
export const GET_UNIMPORTANT_MAIL = 'get_unimportant_mail';
export const GET_UNREAD_MAIL = 'get_unread_mail';
export const GET_UNSELECTED_ALL_MAIL = 'get_unselected_all_mail';
export const GET_UNSTARRED_MAIL = 'get_unstarred_mail';
export const ON_ALL_MAIL_SELECT = 'on_all_mail_select';
export const ON_FOLDER_MENU_ITEM_SELECT = 'on_folder_menu_item_select';
export const ON_FOLDER_SELECT = 'on_folder_select';
export const ON_IMPORTANT_SELECT = 'on_important_select';
export const ON_LABEL_MENU_ITEM_SELECT = 'on_label_menu_item_select';
export const GET_MARK_AS_START = 'get_mark_as_start';
export const ON_LABEL_SELECT = 'on_label_select';
export const ON_MAIL_CHECKED = 'on_mail_checked';
export const ON_MAIL_SELECT = 'on_mail_select';
export const ON_MAIL_SEND = 'on_mail_send';
export const ON_OPTION_MENU_ITEM_SELECT = 'on_option_menu_item_select';
export const ON_OPTION_MENU_SELECT = 'on_option_menu_select';
export const ON_START_SELECT = 'on_start_select';
export const SEARCH_MAIL = 'search_mail';
export const ON_DELETE_MAIL = 'on_delete_mail';
export const SET_CURRENT_MAIL_NULL = 'set_current_mail_null';
export const ON_COMPOSE_MAIL = 'on_compose_mail';

//// TO-DO Module const

export const ON_SORTEND = 'on_sortend';
export const FETCH_ALL_TODO = 'fetch_all_todo';
export const FETCH_ALL_TODO_SUCCESS = 'fetch_all_todo-success';
export const FETCH_ALL_TODO_CONVERSATION = 'fetch_all_todo_conversation';
export const FETCH_ALL_TODO_CONVERSATION_SUCCESS = 'fetch_all_todo_conversation_success';
export const SELECT_ALL_TODO = 'select_all_todo';
export const GET_ALL_TODO = 'get_all_todo';
export const GET_UNSELECTED_ALL_TODO = 'get_unselected_all_todo';
export const GET_STARRED_TODO = 'get_starred_todo';
export const GET_UNSTARRED_TODO = 'get_unstarred_todo';
export const GET_IMPORTANT_TODO = 'get_important_todo';
export const GET_UNIMPORTANT_TODO = 'get_unimportant_todo';
export const ON_LABEL_UPDATE = 'on_label_update';
export const ON_TODO_UPDATE = 'on_todo_update';
export const ON_DELETE_TODO = 'on_delete_todo';
export const SEARCH_TODO = 'search_todo';
export const SHOW_TODOS = 'show_todos';
export const GET_TODO_CONVERSATION = 'get_todo_conversation';
export const ON_TODO_CHECKED = 'on_todo_checked';
export const ON_TODO_ADD = 'on_todo_add';
export const ON_TODO_SELECT = 'on_todo_select';
export const SET_CURRENT_TODO_NULL = 'set_current_todo_null';
export const REMOVE_LABEL = 'remove_label';
export const UPDATE_SEARCH = 'update_search';

// Master Menu Module const 

export const REQ_DATA_MASTER_MENU = 'req_master_menu';
export const GET_DATA_MASTER_MENU = 'get_master_menu';

export const REQ_ADD_MASTER_MENU =  'req_add_master_menu';
export const GET_ADD_MASTER_MENU = 'get_add_master_menu';

export const REQ_EDIT_MASTER_MENU = 'req_edit_master_menu';
export const GET_EDIT_MASTER_MENU = 'get_edit_masterMenu';

export const REQ_DELETE_MASTER_MENU = 'req_delete_master_menu';
export const GET_DELETE_MASTER_MENU = 'get_delete_master_menu';

export const REQ_SETTING_MENU = 'req_setting_menu';
export const REQ_SETTING_MENU_ = 'req_setting_menu_';
export const GET_SETTING_MENU = 'get_setting_menu';

export const SUCCESS_MESSAGE_MENU = 'success_message_menu';
export const ERROR_MESSAGE_MENU = 'error_message_menu';
export const HIDE_MESSAGE_MENU = 'hide_message_menu';


// package Menu Module Const

export const REQ_ALL_PACKAGE = 'req_all_package';
export const REQ_ADD_PACKAGE = 'req_create_package';
export const REQ_EDIT_PACKAGE = 'req_edit_package';
export const REQ_DELETE_PACKAGE = 'req_delete_package';

export const GET_ALL_PACKAGE = 'get_all_package';
export const GET_ADD_PACKAGE = 'get_create_package';
export const GET_EDIT_PACKAGE = 'get_edit_package';
export const GET_DELETE_PACKAGE = 'get_delete_package';

export const SET_PACKAGE_MENU = 'set_package_menu';
export const GET_PACKAGE_MENU = 'get_package_menu';

export const SUCCESS_MESSAGE_PACKAGE = 'success_message_package';
export const ERROR_MESSAGE_PACKAGE = 'error_message_package';
export const HIDE_MESSAGE_PACKAGE = 'hide_message_package';


// User Management Module Const

export const REQ_ADD_DATA_GROUP_USER = 'req_add_data_group_user';
export const GET_ADD_DATA_GROUP_USER = 'get_add_data_group_user';
export const REQ_ALL_GROUP = 'req_all_group';
export const REQ_ADD_GROUP = 'req_add_group';
export const REQ_EDIT_GROUP = 'req_edit_group';
export const REQ_DELETE_GROUP = 'req_delete_group';

export const GET_ALL_GROUP = 'get_all_group';
export const GET_ADD_GROUP = 'req_add_group';
export const GET_EDIT_GROUP = 'req_edit_group';
export const GET_DELETE_GROUP = 'req_delete_group';

export const REQ_SET_USER_MANAGE = 'req_set_user_manage';
export const GET_SET_USER_MANAGE = 'get_set_user_manage';

export const REQ_ALL_COMPANY = 'req_all_company';
export const GET_ALL_COMPANY = 'get_all_company';

export const REQ_POOL_COMPANY = 'req_pool_company';
export const GET_POOL_COMPANY = 'get_pool_company';

export const REQ_VEHICLE_COMPANY = 'req_vehicle_company';
export const GET_VEHICLE_COMPANY = 'get_vehicle_company';

export const REQ_TRANSIT_COMPANY = 'req_transit_company';
export const GET_TRANSIT_COMPANY = 'get_transit_company';

export const REQ_VISITED_PAGE = 'req_visited_page';
export const GET_VISITED_PAGE = 'get_visited_page';

export const SUCCESS_MESSAGE_MANAGE = 'success_message_manage';
export const ERROR_MESSAGE_MANAGE = 'error_message_manage';
export const HIDE_MESSAGE_MANAGE = 'hide_message_manage';


// User Module Const

export const REQ_USER_DATA = 'req_user_data';
export const GET_USER_DATA = 'get_user_data';

export const REQ_ADD_USER_DATA = 'req_add_user_data';
export const GET_ADD_USER_DATA = 'get_add_user_data';

export const REQ_EDIT_USER_DATA = 'req_edit_user_data';

export const REQ_DELETE_USER_DATA = 'req_delete_user_data';

export const REQ_USER_COMPANY = 'req_user_company';
export const GET_USER_COMPANY = 'get_user_company';

export const REQ_DATA_COMPANY = 'req_data_company';
export const GET_DATA_COMPANY = 'get_data_company';

export const SUCCESS_MESSAGE_USER = 'success_message_user';
export const ERROR_MESSAGE_USER = 'error_message_user';
export const HIDE_MESSAGE_USER = 'hide_message_user';


// Operator Module Const

export const REQ_MASTER_DRIVER_DATA = 'req_master_driver_data';
export const GET_MASTER_DRIVER_DATA = 'get_master_driver_data';

export const REQ_ADD_MASTER_DRIVER_DATA = 'req_add_master_driver_data';
export const GET_ADD_MASTER_DRIVER_DATA = 'get_add_master_driver_data';

export const REQ_EDIT_MASTER_DRIVER_DATA = 'req_edit_master_driver_data';

export const REQ_DELETE_MASTER_DRIVER_DATA = 'req_delete_master_driver_data';

export const SUCCESS_MESSAGE_MASTER_DRIVER = 'success_message_master_driver';
export const ERROR_MESSAGE_MASTER_DRIVER = 'error_message_master_driver';
export const HIDE_MESSAGE_MASTER_DRIVER = 'hide_message_master_driver';


// Aset Module Const

export const REQ_MASTER_VEHICLE_DATA = 'req_master_vehicle_data';
export const GET_MASTER_VEHICLE_DATA = 'get_master_vehicle_data';

export const REQ_ADD_MASTER_VEHICLE_DATA = 'req_add_master_vehicle_data';
export const GET_ADD_MASTER_VEHICLE_DATA = 'get_add_master_vehicle_data';

export const REQ_EDIT_MASTER_VEHICLE_DATA = 'req_edit_master_vehicle_data';

export const REQ_DELETE_MASTER_VEHICLE_DATA = 'req_delete_master_vehicle_data';

export const SUCCESS_MESSAGE_MASTER_VEHICLE = 'success_message_master_vehicle';
export const ERROR_MESSAGE_MASTER_VEHICLE = 'error_message_master_vehicle';
export const HIDE_MESSAGE_MASTER_VEHICLE = 'hide_message_master_vehicle';


// Token Module Const

export const REQ_REFRESH_TOKEN = 'req_refresh_token';
export const REQ_CREATE_TOKEN = 'req_create_token';
export const GET_REFRESH_TOKEN = 'get_refresh_token';
export const GET_CREATE_TOKEN = 'get_create_token';

// Get Notif Action 
export const REQ_DATA_NOTIF = 'req_data_notif';
export const GET_DATA_NOTIF = 'get_data_notif';
export const GET_DATA_NOTIF_DOCS = 'get_data_notif_docs';
export const REQ_DATA_NOTIF_DOCS = 'req_data_notif_docs';
export const REQ_DATA_NOTIF_LOCK = 'req_data_notif_lock';
export const GET_DATA_NOTIF_LOCK = 'get_data_notif_lock';
export const CHANGE_STATUS_NOTIF = 'change_status_notif';      


// Import Excel Const
export const SET_WORKBOOK = "SET_WORKBOOK";
export const SET_WORKBOOK_FIX = "SET_WORKBOOK_FIX";
export const SET_DATA_FILE_IMPORT = "SET_DATA_FILE_IMPORT";
export const SAVE_IMPORT = "SAVE_IMPORT";
export const EXPORT_EXCEL = "EXPORT_EXCEL";
export const ADD_COLUMN = "ADD_COLUMN";
export const DELETE_COLUMN = "DELETE_COLUMN";
export const ADD_ROW = "ADD_ROW";
export const DELETE_ROW = "DELETE_ROW";
export const UPDATE_CELL = "UPDATE_CELL";
export const SET_HEADERS = "SET_HEADERS";
export const SET_BODY = "SET_BODY";
export const SET_TABLE = "SET_TABLE";
export const VALIDATE_CELLS = "VALIDATE_CELLS";
export const PARSE_CELLS = "PARSE_CELLS";

// BATCH
export const BATCH_NAME = "BATCH_NAME"



// WEBPACK FOOTER //
// ./constants/ActionTypes.js